module.exports = __webpack_public_path__ + "img/1338238153.2dd00c2a.jpg";